var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.nameClass},[_vm._v("\n  "+_vm._s(_vm.getPrice(_vm.price, _vm.currencyCode, _vm.currency.rates))+"\n  "+_vm._s(_vm.getCurrencyCode(_vm.currencyCode, _vm.currency.code, _vm.currency.rates))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }